import { Component, OnInit, Input } from "@angular/core";
import { GuidService } from "src/app/core/services/guid.service";
import { ClipboardService } from "src/app/core/services/clipboard.service";
import { SnackBarService } from "src/app/core/services/snack-bar.service";

@Component({
    selector: "app-generate-guid",
    templateUrl: "./generate-guid.component.html",
    styleUrls: ["./generate-guid.component.scss"],
    standalone: false
})
export class GenerateGuidComponent implements OnInit {
  @Input() buttonLabel: string;

  constructor(
    private guidService: GuidService,
    private clipboardService: ClipboardService,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit() {}

  onGenerateGuid() {
    this.guidService.getManyGuids$().subscribe(
      guids => {
        if (guids && guids.length > 0) {
          var copy = guids.join("\r\n");
          this.clipboardService.copyToClipboard(copy);
          this.snackBarService.show({ message: "Copied to clipboard", panelClass: "copied-snackbar" });
        } else {
          this.snackBarService.show({ message: "Failed, try again", panelClass: "copied-snackbar" });
        }
      },
      err => {
        this.snackBarService.show({ message: "Failed, try again", panelClass: "copied-snackbar" });
      }
    );
  }
}
